import { render, staticRenderFns } from "./serverPdfBase.vue?vue&type=template&id=325fb970&scoped=true"
import script from "./serverPdfBase.vue?vue&type=script&lang=js"
export * from "./serverPdfBase.vue?vue&type=script&lang=js"
import style0 from "./serverPdfBase.vue?vue&type=style&index=0&id=325fb970&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325fb970",
  null
  
)

export default component.exports